import React from "react";
import { useDispatch } from "react-redux";
import { toggleNavigatePanel } from "../../../REDUX/RegistrationModalToggle/toggleModal";
import Logo from "../../Components/CompanyLogo";
import NavCart from "../CenterNavbar/NavCart";

const MobileNav = () => {
  const dispatch = useDispatch();

  function ShowNavigatePanelModalFUnc() {
    dispatch(toggleNavigatePanel());
  }
  return (
    <div className="md:hidden">
      <div className="flex justify-around items-center">
        <div>
          <Logo />
        </div>
        <div className="flex items-center justify-center space-x-3">
          <span>
            <i className="mx-2 text-center font-bold bi bi-heart"></i>
          </span>
          <span>
            {/* <i className="mx-2 text-center font-bold bi bi-cart"></i> */}
            <NavCart />
          </span>
          <span onClick={ShowNavigatePanelModalFUnc}>
            <i className="mx-2 text-center font-bold bi bi-list"></i>
          </span>
        </div>
      </div>
    </div>
  );
};

export default MobileNav;
